"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimplifiedCustomDatePickerWidget = void 0;
var React = require("react");
var react_datepicker_1 = require("react-datepicker");
var en_GB_1 = require("date-fns/locale/en-GB");
require("react-datepicker/src/stylesheets/datepicker.scss");
var moment = require("moment");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var react_html_parser_1 = require("react-html-parser");
var FalconQuestionWidgetBase_1 = require("./FalconQuestionWidgetBase");
var SimplifiedCustomDatePickerWidget = exports.SimplifiedCustomDatePickerWidget = /** @class */ (function (_super) {
    __extends(SimplifiedCustomDatePickerWidget, _super);
    function SimplifiedCustomDatePickerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.bindToField = function (date) {
            var dateMoment = moment(date, moment.ISO_8601);
            var formattedDate = dateMoment.format("YYYY-MM-DD");
            if (dateMoment.isValid()) {
                _this.props.onStateChange(_this.props.question.interactionField, formattedDate);
                _this.changelogRecorder.recordQuestion("change", _this.props);
            }
            _this.validateInternal(formattedDate);
        };
        _this.handleChange = function (date) {
            _this.setState({ date: date, dateClicked: true });
        };
        _this.setDate = function () {
            if (_this.state.date) {
                _this.bindToField(_this.state.date);
                _this.calendarRef.current.setOpen(false);
                _this.executeEvent("change");
            }
        };
        _this.monthsToShow = function () {
            return moment(_this.maxDate).startOf("month").diff(moment(_this.minDate).startOf("month"), "months") + 1;
        };
        _this.state = {
            date: null,
            latestUpcomingMtaStartDate: null,
            dateClicked: false
        };
        (0, react_datepicker_1.registerLocale)("enGB", en_GB_1.default);
        _this.minDateExpression = _this.getSetting("minDateExpression", undefined);
        _this.maxDateExpression = _this.getSetting("maxDateExpression", undefined);
        _this.footerHtml = _this.getSetting("footerHtml", undefined);
        if (_this.minDateExpression) {
            var evaluatedDate = moment(moment.utc(journey_services_1.ExpressionEvaluator.evaluateExpression(_this.minDateExpression, _this.props.interaction, new Date()), moment.ISO_8601).format("YYYY-MM-DD"));
            _this.minDate = evaluatedDate.isAfter(moment()) ? evaluatedDate.toDate() : new Date();
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is unable to obtain 'minDateExpression'"));
        }
        if (_this.maxDateExpression) {
            _this.maxDate = moment(moment.utc(journey_services_1.ExpressionEvaluator.evaluateExpression(_this.maxDateExpression, _this.props.interaction, moment(30, "d").toDate()), moment.ISO_8601).format("YYYY-MM-DD")).toDate();
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is unable to obtain 'maxDateExpression'"));
        }
        _this.calendarRef = React.createRef();
        return _this;
    }
    SimplifiedCustomDatePickerWidget.prototype.renderInputField = function () {
        var _this = this;
        var DateInput = function (_a) {
            var value = _a.value, onClick = _a.onClick;
            return (React.createElement("div", { className: "datePickerSelect row" },
                React.createElement("div", { onClick: onClick, onKeyPress: onClick, className: "col-md-12" },
                    React.createElement("input", { onClick: _this.executeNativeEvent, type: "radio", name: "date", value: "calendar", id: "datePickerCalendar", role: "dialog", checked: !!_this.state.date }),
                    React.createElement("label", { htmlFor: "datePickerCalendar", tabIndex: 0, "aria-label": "Choose date from calendar" },
                        _this.state.date ? value : "Please select date",
                        React.createElement("span", { className: _this.state.date ? "calendar-icon-selected" : "calendar-icon" }),
                        React.createElement("span", { className: "calendar-arrow-icon" })))));
        };
        return (React.createElement("div", { className: "w-100" },
            React.createElement(react_datepicker_1.default, { ref: this.calendarRef, onChange: this.handleChange, selected: this.state.date, customInput: React.createElement(DateInput, null), locale: "enGB", dateFormat: "dd MMM yyyy", minDate: this.minDate, maxDate: this.maxDate, dayClassName: this.dayClassName, showPreviousMonths: false, showDisabledMonthNavigation: false, disabledKeyboardNavigation: true, shouldCloseOnSelect: false, monthsShown: this.monthsToShow(), showPopperArrow: false, withPortal: true },
                React.createElement("div", { className: "react-datepicker__footer" }, this.renderFooterHtml()),
                React.createElement("div", { className: "d-flex justify-content-center mr-5 ml-5" }, this.renderSelectDateButton()))));
    };
    SimplifiedCustomDatePickerWidget.prototype.renderFooterHtml = function () {
        var evaluatedString = journey_services_1.ExpressionEvaluator.renderTemplate(this.footerHtml, this.props.interaction, true);
        return (0, react_html_parser_1.default)(evaluatedString, { transform: function (node) {
                if (node.name === 'script' || node.name === 'style' || node.name === 'link') {
                    return null;
                }
                return;
            } });
    };
    SimplifiedCustomDatePickerWidget.prototype.renderSelectDateButton = function () {
        return (React.createElement("button", { type: "button", className: "btn btn-primary btn-next-arrow-separate", onClick: this.setDate, id: "set-date", disabled: !this.state.date },
            "Select date",
            React.createElement("img", { className: "arrow-next", alt: "", src: "/img/arrow-next.png" })));
    };
    SimplifiedCustomDatePickerWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "footerHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "minDateExpression", type: journey_model_1.TypeDescriptions.String },
            { name: "maxDateExpression", type: journey_model_1.TypeDescriptions.String },
            { name: "nextButtonName", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], SimplifiedCustomDatePickerWidget);
    return SimplifiedCustomDatePickerWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
//# sourceMappingURL=SimplifiedCustomDatePickerWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/SimplifiedCustomDatePickerWidget.js
// module id = 3651
// module chunks = 0